(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (() => {
    const baseUrl = 'https://cdn.shopify.com/s/files/1/0995/6094/8019/files/reviews-bucket-{key}.svg';
    const versions = {
      '0':'1786981354','1':'1786981395','2':'1786981405','3':'1786981413','4':'1786981423',
      '5':'1786981433','6':'1786981441','7':'1786981450','8':'1786981461','9':'1786981469',
      'a':'1786981478','b':'1786981490','c':'1786981504','d':'1786981513','e':'1786981522',
      'f':'1786981533','g':'1786981541','h':'1786981549','i':'1786981559','j':'1786981567',
      'k':'1786981576','l':'1786981587','m':'1786981615','n':'1786981624','o':'1786981632',
      'p':'1786981640','q':'1786981650','r':'1786981659','s':'1786981666','t':'1786981673',
      'u':'1786981683','v':'1786981693','w':'1786981707','y':'1786981715'
    };

    const normalizeSku = (value) => String(value || '').trim().toLowerCase();
    const bucketKey = (sku) => normalizeSku(sku).replace(/[^a-z0-9]/g, '').slice(0, 1);

    function ratingStats(reviews) {
      const numericRatings = reviews
        .map(({ row, positions }) => Number.parseFloat(row[positions['Rating']]))
        .filter(Number.isFinite);
      const average = numericRatings.length
        ? numericRatings.reduce((total, value) => total + value, 0) / numericRatings.length
        : 0;
      return { average, count: reviews.length };
    }

    function setStarFill(element, rating) {
      if (!element) return;
      const numericRating = Number.parseFloat(rating);
      const percent = Number.isFinite(numericRating)
        ? Math.max(0, Math.min(100, (numericRating / 5) * 100))
        : 0;
      element.style.setProperty('--cdc-rating-percent', `${percent}%`);
    }

    function renderTopSummary(loader, reviews) {
      const summary = document.getElementById(loader.dataset.ratingSummaryId || '');
      if (!summary) return;

      const reviewsLabel = loader.dataset.reviewsLabel || 'reviews';
      let average = 0;
      let count = 0;

      if (reviews.length) {
        const stats = ratingStats(reviews);
        average = stats.average;
        count = stats.count;
      } else {
        average = Number.parseFloat(summary.dataset.fallbackRating || '');
        count = Number.parseInt(summary.dataset.fallbackCount || '0', 10);
      }

      if (!Number.isFinite(average) || average <= 0 || !Number.isFinite(count) || count <= 0) {
        summary.hidden = true;
        return;
      }

      setStarFill(summary.querySelector('[data-cdc-summary-stars]'), average);
      const averageElement = summary.querySelector('[data-cdc-summary-average]');
      if (averageElement) averageElement.textContent = average.toFixed(1);
      const countElement = summary.querySelector('[data-cdc-summary-count]');
      if (countElement) countElement.textContent = `(${count} ${reviewsLabel})`;
      summary.hidden = false;
    }

    async function gunzipBase64(value) {
      if (!('DecompressionStream' in window)) return null;
      const binary = atob(value.trim());
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
      const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
      return new Response(stream).text();
    }

    async function loadBucket(key) {
      const version = versions[key];
      if (!key || !version) return [];
      const url = `${baseUrl.replace('{key}', key)}?v=${version}`;
      const response = await fetch(url, { credentials: 'omit' });
      if (!response.ok) return [];
      const svgText = await response.text();
      const documentSvg = new DOMParser().parseFromString(svgText, 'image/svg+xml');
      const metadata = documentSvg.getElementById('cdc-review-data');
      if (!metadata) return [];
      const jsonText = await gunzipBase64(metadata.textContent || '');
      if (!jsonText) return [];
      const payload = JSON.parse(jsonText);
      if (!Array.isArray(payload.columns) || !Array.isArray(payload.rows)) return [];
      const positions = Object.fromEntries(payload.columns.map((column, index) => [column, index]));
      return payload.rows.map((row) => ({ row, positions }));
    }

    function createTextElement(tag, className, text) {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = text == null ? '' : String(text);
      return element;
    }

    function renderReviews(loader, reviews) {
      renderTopSummary(loader, reviews);
      if (!reviews.length) return;

      const reviewsLabel = loader.dataset.reviewsLabel || 'reviews';
      const showMoreLabel = loader.dataset.showMoreLabel || 'Show more';
      const showLessLabel = loader.dataset.showLessLabel || 'Show less';
      const productId = loader.dataset.productId || 'product';
      const sectionId = `cdc-product-reviews-${productId}`;
      const existing = document.getElementById(sectionId);
      if (existing) existing.remove();

      const stats = ratingStats(reviews);
      const average = stats.average;
      const section = document.createElement('section');
      section.id = sectionId;
      section.className = 'cdc-product-reviews';

      const header = document.createElement('div');
      header.className = 'cdc-product-reviews__header';
      header.appendChild(createTextElement('h2', 'cdc-product-reviews__title', reviewsLabel));

      const summary = document.createElement('div');
      summary.className = 'cdc-product-reviews__summary';
      const headerStars = createTextElement('span', 'cdc-review-stars', '★★★★★');
      headerStars.setAttribute('aria-hidden', 'true');
      setStarFill(headerStars, average);
      summary.appendChild(headerStars);
      summary.appendChild(createTextElement('span', 'cdc-product-reviews__average', `${average.toFixed(1)} / 5`));
      summary.appendChild(createTextElement('span', 'cdc-product-reviews__count', `${reviews.length} ${reviewsLabel}`));
      header.appendChild(summary);
      section.appendChild(header);

      const list = document.createElement('div');
      list.className = 'cdc-product-reviews__list';
      const expandableCards = [];

      reviews.forEach(({ row, positions }, index) => {
        const card = document.createElement('article');
        card.className = 'cdc-review-card';
        if (index >= 2) {
          card.hidden = true;
          expandableCards.push(card);
        }

        const top = document.createElement('div');
        top.className = 'cdc-review-card__top';
        top.appendChild(createTextElement('p', 'cdc-review-card__reviewer', row[positions['Reviewer Name']]));
        top.appendChild(createTextElement('time', 'cdc-review-card__date', row[positions['Review Date']]));
        card.appendChild(top);

        const ratingValue = row[positions['Rating']];
        const ratingRow = document.createElement('div');
        ratingRow.className = 'cdc-review-card__rating';
        const reviewStars = createTextElement('span', 'cdc-review-stars', '★★★★★');
        reviewStars.setAttribute('aria-hidden', 'true');
        setStarFill(reviewStars, ratingValue);
        ratingRow.appendChild(reviewStars);
        ratingRow.appendChild(createTextElement('span', '', `${ratingValue} / 5`));
        card.appendChild(ratingRow);

        const title = row[positions['Review Title']];
        if (title) card.appendChild(createTextElement('h3', 'cdc-review-card__title', title));
        const text = row[positions['Review Text']];
        if (text) card.appendChild(createTextElement('p', 'cdc-review-card__text', text));
        list.appendChild(card);
      });

      section.appendChild(list);

      if (expandableCards.length) {
        const toggleWrap = document.createElement('div');
        toggleWrap.className = 'cdc-product-reviews__toggle-wrap';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'cdc-product-reviews__toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = `${showMoreLabel} (${expandableCards.length})`;

        toggle.addEventListener('click', () => {
          const expanding = toggle.getAttribute('aria-expanded') !== 'true';
          expandableCards.forEach((card) => { card.hidden = !expanding; });
          toggle.setAttribute('aria-expanded', expanding ? 'true' : 'false');
          toggle.textContent = expanding ? showLessLabel : `${showMoreLabel} (${expandableCards.length})`;
        });

        toggleWrap.appendChild(toggle);
        section.appendChild(toggleWrap);
      }

      const productSection = loader.closest('.shopify-section') || loader.closest('section');
      if (productSection) productSection.insertAdjacentElement('afterend', section);
    }

    async function initializeLoader(loader) {
      if (loader.dataset.cdcReviewLoaded === 'true') return;
      loader.dataset.cdcReviewLoaded = 'true';

      let skus = [];
      try { skus = JSON.parse(loader.dataset.skus || '[]'); } catch (error) { skus = []; }
      const normalizedSkus = new Set(skus.map(normalizeSku).filter(Boolean));
      if (!normalizedSkus.size) {
        renderTopSummary(loader, []);
        return;
      }

      const keys = [...new Set([...normalizedSkus].map(bucketKey).filter(Boolean))];
      try {
        const bucketResults = await Promise.all(keys.map(loadBucket));
        const reviews = bucketResults.flat().filter(({ row, positions }) =>
          normalizedSkus.has(normalizeSku(row[positions['Product SKU']]))
        );
        renderReviews(loader, reviews);
      } catch (error) {
        renderTopSummary(loader, []);
        console.warn('Customer reviews could not be loaded.', error);
      }
    }

    function initializeAll() {
      document.querySelectorAll('[data-cdc-review-loader]').forEach(initializeLoader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
